import { Component } from '@angular/core';
import { CacheResolverService } from './core/cache/cache-resolver.service';
import { CacheConstant } from './core/cache/cache.constant';
import { AppConstant } from './core/constants/app.constant';
import { RouteUtilService } from './shared/utils/route-util.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
constructor(private routeUtils: RouteUtilService,
           private cacheService: CacheResolverService,
  private router: Router,
            private dialog: MatDialog
){

}
  ngOnInit() {

    const roleAssigned = this.cacheService.get(CacheConstant.LocalStorage.NoRoleAssigned)?.roleAssigned ?? false;
    if(roleAssigned == AppConstant.Messages.AccountRoles.OnlyInvoice)
    {
      this.routeUtils.navigate('/reports/invoices');
    }
    else{
      this.routeUtils.navigate('/');

    }
    this.router.events.subscribe(() => {
      this.dialog.closeAll();
      setTimeout(() => {
        document
          .querySelectorAll('.cdk-overlay-backdrop')
          .forEach(el => el.remove());
      });
    });

    /***Added logs to debug cache issues ***/
    console.log("Current URL: ", window.location.href);
    console.log("refreshtoken:", sessionStorage.getItem('refreshtoken'));
    console.log("authtoken:", sessionStorage.getItem('authtoken'));
    console.log("shipto:", localStorage.getItem('shipto'));
    console.log('Local Storage Keys',Object.keys(localStorage));
    console.log('Session Storage Keys',Object.keys(sessionStorage));

  }
    
}
